/* Party Games — v1.0.3 (20-ago-26): video com audio ao clicar, sem travar
   a imagem (fix do bug reportado na v1.0.2: 'o audio comeca, mas a imagem
   fica travada, precisa pausar e dar play de novo').

   Causa raiz da v1.0.2: o video usa preload:'none' e o Dawn ja chama
   video.play() sozinho assim que o <video> e inserido (loadContent(), "force
   autoplay for safari"). Nosso script rodava um SEGUNDO video.play() quase
   no mesmo instante, ANTES do video ter qualquer frame decodificado
   (readyState ainda HAVE_NOTHING/HAVE_METADATA) — dois play() concorrentes
   nesse estado destravam o audio mas deixam o pipeline de video preso no
   poster/primeiro frame, so' desempacando com um pause+play manual.

   Fix: nao chamamos mais play() de imediato. Esperamos o evento
   'loadeddata'/'canplay' (o navegador ja decodificou frame(s) reais) antes
   de mexer em qualquer coisa. Nesse ponto so' desmutamos (video.muted =
   false) — como o video ja esta tocando (autoplay nativo do Dawn), NAO
   chamamos play() de novo (evita o play() duplo que causou o travamento).
   Só chamamos play() nosso se o video estiver mesmo pausado nesse momento
   (fallback caso o autoplay nativo nao tenha disparado).

   Continua tudo disparado SO por clique real (nenhum swipe/visibilidade/
   slide-inicial aciona isso — ver comentario da v1.0.2 no historico do
   arquivo). Cobre galeria inline (.product__media-list) e modal de zoom
   (.product-media-modal__content). Escopo: toda pagina de produto, todo
   produto. Incluido via snippets/product-media-gallery.liquid logo apos
   </media-gallery>. */
(function () {
  function finishUnmute(video) {
    video.muted = false;
    if (video.paused) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          video.muted = true;
          video.play().catch(function () {});
        });
      }
    }
  }

  function tryUnmuteAndPlay(video) {
    if (!video || video.dataset.pgUnmuteTried === '1') return;
    video.dataset.pgUnmuteTried = '1';

    // HAVE_CURRENT_DATA (2) ou mais = ja tem pelo menos um frame decodificado.
    if (video.readyState >= 2) {
      finishUnmute(video);
      return;
    }

    var done = false;
    function onReady() {
      if (done) return;
      done = true;
      finishUnmute(video);
    }
    video.addEventListener('loadeddata', onReady, { once: true });
    video.addEventListener('canplay', onReady, { once: true });
  }

  function handleAddedNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'VIDEO') {
      tryUnmuteAndPlay(node);
      return;
    }
    if (node.querySelectorAll) {
      var videos = node.querySelectorAll('video');
      videos.forEach(tryUnmuteAndPlay);
    }
  }

  function observeContainer(container) {
    if (!container || container.dataset.pgVideoObserved === '1') return;
    container.dataset.pgVideoObserved = '1';
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(handleAddedNode);
      });
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('media-gallery .product__media-list').forEach(observeContainer);
    document.querySelectorAll('.product-media-modal__content').forEach(observeContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
